import { Component, Input } from '@angular/core';
import { Step } from '../booking/model/booking.model';

@Component({
  selector: 'markant-platform-booking-header',
  templateUrl: './booking-header.component.html',
  styleUrls: ['./booking-header.component.scss'],
})
export class BookingHeaderComponent {
  @Input() cartridgeId!: string;
  @Input() priceRequestId?: string;
  @Input() cartridgeVariantName!: string;
  @Input() bookingStep!: Step;

  routerLink!: string[];
}
